export enum InterviewSchedulesCollectionScopes {
  Main = 'main',
  Available = 'available',
}
